import { AiResumeReviewMobilePanel } from 'builder/components/AiFeatures/AiResumeReview'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { MobileContainer, StyledAiResumeReview } from './styles'

type Props = {
  canScrollBottom?: boolean
}

export const AIReviewContent = (props: Props) => {
  const { canScrollBottom } = props
  const { isTablet } = useMediaQueries()
  return isTablet ? (
    <MobileContainer>
      <AiResumeReviewMobilePanel isInModalWindow={false} canScrollBottom={canScrollBottom} />
    </MobileContainer>
  ) : (
    <StyledAiResumeReview />
  )
}
